import { useCallback } from 'react';
import { usePlayerContext } from '../../ui-react/PlayerContext';
import { useStore } from '../../ui-react/hooks/useStore';
import { ClipsIcon } from './ClipsIcon';
import { Tooltip } from '../../ui-react/controls/Tooltip';
import styles from './ClipsButton.module.css';

export function ClipsButton() {
  const { store, eventBus } = usePlayerContext();
  const isAvailable = useStore(store, useCallback(s => s.clipsAvailable, []));

  const handleClick = useCallback(() => {
    eventBus.emit('clips:create');
  }, [eventBus]);

  if (!isAvailable) return null;

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.btn}
        aria-label="Создать клип"
        onClick={handleClick}
      >
        <ClipsIcon />
      </button>
      <Tooltip label="Создать клип" shortcut="Alt + x" />
    </div>
  );
}